import React, { useCallback } from 'react';
import { EntityTypeType } from '~/components/Admin';
import { AdminServiceEvents, ServicesContext } from '~/services';

export const useRemoveUserRole = (events: AdminServiceEvents) => {
    const services = React.useContext(ServicesContext);

    const removeUserRole = useCallback(
        async (id: number, entityType: EntityTypeType) => {
            await services.api.call({
                method: 'delete',
                url: `/api/${entityType}-users/${id}`,
            });
            services.events.publish(events[`user_${entityType}_removed`], id);
        },
        [services.api, services.events, events]
    );

    return removeUserRole;
};
